module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.applicationTitle) + " for\n                        "), (_vm.selected_apply_org_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_org_id_details.name) + " (" + _vm._s(_vm.selected_apply_org_id_details.abn) + ")")]) : _vm._e(), _vm._v(" "), (_vm.selected_apply_proxy_id) ? _c('span', [_vm._v(_vm._s(_vm.selected_apply_proxy_id_details.first_name) + " " + _vm._s(_vm.selected_apply_proxy_id_details.last_name) + " (" + _vm._s(_vm.selected_apply_proxy_id_details.email) + ")")]) : _vm._e(), _vm._v(" "), (!_vm.selected_apply_org_id && !_vm.selected_apply_proxy_id) ? _c('span', [_vm._v("yourself")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [(_vm.categoryCount) ? _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current_user.is_reception),
      expression: "current_user.is_reception"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("\n                                    Payment method for customer:\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "checked": "checked",
      "name": "reception",
      "value": "card"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "card")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "card"
      }
    }
  }), _vm._v(" Credit Card   "), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "name": "reception",
      "id": "cash",
      "value": "cash"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "cash")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "cash"
      }
    }
  }), _vm._v(" Cash   "), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_pay_method),
      expression: "customer_pay_method"
    }],
    attrs: {
      "type": "radio",
      "name": "reception",
      "id": "none",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.customer_pay_method, "none")
    },
    on: {
      "change": function($event) {
        _vm.customer_pay_method = "none"
      }
    }
  }), _vm._v(" No Payment   ")])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                                    " + _vm._s(_vm.selectionLabel) + ":\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-left-20"
  }, _vm._l((_vm.visibleLicenceCategories), function(category, index) {
    return _c('div', {
      staticClass: "radio"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-9"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.licence_categories.id),
        expression: "licence_categories.id"
      }],
      attrs: {
        "type": "radio",
        "id": category.id,
        "name": "licence_category"
      },
      domProps: {
        "value": category.id,
        "checked": _vm._q(_vm.licence_categories.id, category.id)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.licence_categories, "id", category.id)
        }, function($event) {
          return _vm.handleRadioChange($event, index)
        }]
      }
    }), _vm._v(" " + _vm._s(category.short_name) + "\n                                         \n                                        "), _c('div', {
      staticClass: "row"
    }, [(category.checked) ? _c('div', {
      staticClass: "col-sm-9"
    }, _vm._l((category.activity), function(type, index1) {
      return (!(_vm.selected_apply_org_id != '' && type.not_for_organisation == true)) ? _c('div', {
        staticClass: "checkbox margin-left-20"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (category.activity[index1].selected),
          expression: "category.activity[index1].selected"
        }],
        ref: "selected_activity_type",
        refInFor: true,
        attrs: {
          "type": "checkbox",
          "name": "activity",
          "id": type.id
        },
        domProps: {
          "value": type.id,
          "checked": Array.isArray(category.activity[index1].selected) ? _vm._i(category.activity[index1].selected, type.id) > -1 : (category.activity[index1].selected)
        },
        on: {
          "change": [function($event) {
            var $$a = category.activity[index1].selected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = type.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(category.activity[index1], "selected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(category.activity[index1], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(category.activity[index1], "selected", $$c)
            }
          }, function($event) {
            return _vm.handleActivityCheckboxChange(index, index1)
          }]
        }
      }), _vm._v(" " + _vm._s(type.short_name) + "\n\n                                                    "), (type.selected) ? _c('div', _vm._l((type.purpose), function(purpose, index2) {
        return _c('div', {
          staticClass: "checkbox purpose-clear-left"
        }, [(purpose.is_valid_age) ? _c('div', {
          staticClass: "col-sm-12"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (type.purpose[index2].selected),
            expression: "type.purpose[index2].selected"
          }],
          attrs: {
            "type": "checkbox",
            "id": purpose.id
          },
          domProps: {
            "value": purpose.id,
            "checked": Array.isArray(type.purpose[index2].selected) ? _vm._i(type.purpose[index2].selected, purpose.id) > -1 : (type.purpose[index2].selected)
          },
          on: {
            "change": [function($event) {
              var $$a = type.purpose[index2].selected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = purpose.id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(type.purpose[index2], "selected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(type.purpose[index2], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(type.purpose[index2], "selected", $$c)
              }
            }, function($event) {
              return _vm.handlePurposeCheckboxChange(index, $event)
            }]
          }
        }), _vm._v("\n                                                                        " + _vm._s(purpose.name) + "\n                                                                        "), _c('span', [_vm._v(" (" + _vm._s(_vm._f("toCurrency")(parseFloat(purpose.base_application_fee))) + " + " + _vm._s(_vm._f("toCurrency")(parseFloat(purpose.base_licence_fee))) + ")")])]) : _c('div', {
          staticClass: "col-sm-12"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (type.purpose[index2].selected),
            expression: "type.purpose[index2].selected"
          }],
          attrs: {
            "type": "checkbox",
            "disabled": "",
            "id": purpose.id
          },
          domProps: {
            "value": purpose.id,
            "checked": Array.isArray(type.purpose[index2].selected) ? _vm._i(type.purpose[index2].selected, purpose.id) > -1 : (type.purpose[index2].selected)
          },
          on: {
            "change": function($event) {
              var $$a = type.purpose[index2].selected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = purpose.id,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(type.purpose[index2], "selected", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(type.purpose[index2], "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(type.purpose[index2], "selected", $$c)
              }
            }
          }
        }), _vm._v("\n                                                                " + _vm._s(purpose.name) + "\n                                                                "), _c('span', [_vm._v(" (Minimum age " + _vm._s(purpose.minimum_age) + " years)")])])])
      }), 0) : _vm._e()]) : _vm._e()
    }), 0) : _c('div', {
      staticClass: "col-sm-4"
    })])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Continue")]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('strong', [_vm._v("Estimated application fee: " + _vm._s(_vm._f("toCurrency")(_vm.application_fee)))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Estimated licence fee: " + _vm._s(_vm._f("toCurrency")(_vm.licence_fee)))]), _c('br')])])]) : (!_vm.categoryCount && (_vm.isAmendment || _vm.isRenewal)) ? _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('center', [_c('i', {
    staticClass: "fa fa-4x fa-spinner fa-spin"
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')], 1)])]) : _c('div', [_vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ffdb1b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/application_apply_licence.vue
// module id = 913
// module chunks = 0